












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Banner extends Vue {
  @Prop() private color!: string;
  @Prop() private header!: string;
  @Prop() private sub!: string;
  @Prop() private image!: string;
  @Prop() private tall: boolean = true;
}
